import React, { useEffect } from 'react';
import { Search } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { getUserDisplayName } from '../../../utils/userName';

const timeGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 17) return 'Good afternoon';
  if (hour >= 17 && hour < 22) return 'Good evening';
  return 'Hello';
};

const MobileGreeting = ({ userName: _userName }) => {
  const { normalizedUser } = useAuth();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('Dashboard user:', normalizedUser);
    }
  }, [normalizedUser]);

  const displayName = getUserDisplayName({ ...normalizedUser, fullName: normalizedUser?.fullName || _userName || '' });
  const greeting = timeGreeting();

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-semibold text-notion-text tracking-tight mb-1">
        {greeting}{displayName !== 'there' ? `, ${displayName}` : ''}
      </h1>
      <p className="text-notion-text-light text-sm mb-4">Here is your pipeline today.</p>

      {/* Search (kept for mobile dashboard) */}
      <div className="relative group w-full">
        <Search className="absolute left-3 top-2.5 w-4 h-4 text-notion-text-light" />
        <input
          type="text"
          placeholder="Search leads, notes..."
          className="w-full pl-10 pr-4 py-2 bg-notion-sidebar border border-transparent focus:bg-white focus:border-stone-300 rounded-lg text-sm focus:outline-none transition-all placeholder-notion-text-light text-notion-text shadow-sm"
        />
      </div>
    </div>
  );
};

export default MobileGreeting;
